import { render, staticRenderFns } from "./layout-center.vue?vue&type=template&id=3fade3cd&scoped=true"
import script from "./layout-center.vue?vue&type=script&lang=js"
export * from "./layout-center.vue?vue&type=script&lang=js"
import style0 from "./layout-center.vue?vue&type=style&index=0&id=3fade3cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fade3cd",
  null
  
)

export default component.exports